import type { FC } from 'react';
import { Checkbox } from '@mantine/core';
import classes from './BaseMapGroupControl.module.css';

interface Props {
  title?: string;
  showLabels?: boolean;
  toggleLabels?: (e: boolean) => void;
  enableCustomBaseMap?: boolean;
  children?: React.ReactNode;
  'data-testid'?: string;
}

export const BaseMapGroupControl: FC<Props> = ({
  title = 'Background map',
  showLabels = true,
  enableCustomBaseMap = false,
  ...props
}) => {
  return (
    <div className={classes.wrapper} data-testid={props['data-testid']}>
      <span>{title}</span>
      <div className={classes.baseOptions}>{props.children}</div>
      {enableCustomBaseMap && props.toggleLabels && (
        <Checkbox
          label="Show labels"
          name="baseMapLabels"
          checked={showLabels}
          onChange={(e) => props.toggleLabels?.(e.currentTarget.checked)}
          labelPosition="left"
          styles={{ body: { width: '100%', justifyContent: 'space-between' } }}
        />
      )}
    </div>
  );
};
